import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'ar_XH',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  '7af89701-ed16-4dc4-932a-14a4743dd4c6',
  'rtl'
);
